export default __webpack_public_path__ + "static/media/woo-commerce-logo.7ce86149.svg";